/**
 * 👉 Affected endpoints
 * GET /public/stats/manfredites
 */
export class StatsManfreditesResponse {
    static _OPENAPI_METADATA_FACTORY() {
        return { hasEnoughManfredites: { required: true, type: () => Boolean }, stats: { required: false, type: () => require("./stats-manfredites.response").StatsManfreditesResponseStats } };
    }
}
export class StatsManfreditesResponseStats {
    static _OPENAPI_METADATA_FACTORY() {
        return { manfreditesCount: { required: false, type: () => Number }, salariesHeatMap: { required: true, type: () => require("./stats-manfredites.response").StatsManfreditesResponseSalariesHeatMap }, remoteOptionsPercentages: { required: true, type: () => require("./stats-manfredites.response").StatsManfreditesResponseRemoteOptionsPercentages }, manfredites: { required: true, type: () => [require("./stats-manfredites.response").StatsManfreditesResponseManfredite] } };
    }
}
export class StatsManfreditesResponseManfredite {
    static _OPENAPI_METADATA_FACTORY() {
        return { roles: { required: true, type: () => [String] }, mainTechs: { required: true, type: () => [String] }, techs: { required: true, type: () => [String] }, experienceRange: { required: true, type: () => String }, salaryRange: { required: true, type: () => String }, wantsRemote: { required: true, type: () => Boolean }, wantsHybrid: { required: true, type: () => Boolean }, wantsFaceToFace: { required: true, type: () => Boolean }, contractTypes: { required: false, type: () => [Object] }, lastUpdate: { required: false, type: () => Date } };
    }
}
export class StatsManfreditesResponseSalariesHeatMap {
    static _OPENAPI_METADATA_FACTORY() {
        return { salaryLabels: { required: true, type: () => [String] }, experienceLabels: { required: true, type: () => [String] }, heatMap: { required: true, type: () => [[Number]] } };
    }
}
export class StatsManfreditesResponseRemoteOptionsPercentages {
    static _OPENAPI_METADATA_FACTORY() {
        return { remote: { required: true, type: () => Number }, hybrid: { required: true, type: () => Number }, onSite: { required: true, type: () => Number } };
    }
}
//# sourceMappingURL=stats-manfredites.response.js.map